export const modalState = {
  state: () => ({
    showMainMenu: false,
    showProfileMenu: false,
    showGenerateSearchReport: false,
    showInformationModal: false,
    showNewConfirmationModal: false,
    showNewSearchModal: false,
    showListQueriesModal: false,
    showImportModal: false,
    showSaveModal: false,
    showSaveAsModal: false,
    showEnterQueryStringModal: false,
    showShareModal: false,
    showShareSetNameModal: false,
    showQuerySettingsModal: false,
    showUserSettingsModal: false
  }),
  mutations: {
    setShowMainMenu (state, showMainMenu) {
      state.showMainMenu = showMainMenu
    },
    toggleShowMainMenu (state) {
      state.showMainMenu = !state.showMainMenu
    },
    setShowProfileMenu (state, showProfileMenu) {
      state.showProfileMenu = showProfileMenu
    },
    toggleShowProfileMenu (state) {
      state.showProfileMenu = !state.showProfileMenu
    },
    setShowGenerateSearchReport (state, showGenerateSearchReport) {
      state.showGenerateSearchReport = showGenerateSearchReport
    },
    setShowInformationModal (state, showInformationModal) {
      state.showInformationModal = showInformationModal
    },
    setShowNewConfirmationModal (state, showNewConfirmationModal) {
      state.showNewConfirmationModal = showNewConfirmationModal
    },
    setShowNewSearchModal (state, showNewSearchModal) {
      state.showNewSearchModal = showNewSearchModal
    },
    setShowListQueriesModal (state, showListQueriesModal) {
      state.showListQueriesModal = showListQueriesModal
    },
    setShowImportModal (state, showImportModal) {
      state.showImportModal = showImportModal
    },
    setShowSaveModal (state, showSaveModal) {
      state.showSaveModal = showSaveModal
    },
    setShowSaveAsModal (state, showSaveAsModal) {
      state.showSaveAsModal = showSaveAsModal
    },
    setShowEnterQueryStringModal (state, showEnterQueryStringModal) {
      state.showEnterQueryStringModal = showEnterQueryStringModal
    },
    setShowShareModal (state, showShareModal) {
      state.showShareModal = showShareModal
    },
    setShowShareSetNameModal (state, showShareSetNameModal) {
      state.showShareSetNameModal = showShareSetNameModal
    },
    setShowQuerySettingsModal (state, showQuerySettingsModal) {
      state.showQuerySettingsModal = showQuerySettingsModal
    },
    setShowUserSettingsModal (state, showUserSettingsModal) {
      state.showUserSettingsModal = showUserSettingsModal
    }
  },
}



//////////////////
// WEBPACK FOOTER
// ./store/modalState.js
// module id = null
// module chunks = 